exports = module.exports = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagebox[data-v-3a83cc22] {\n  text-align: right;\n  margin-top: 15px;\n}\n", ""]);

// exports
